define("Modules/Map", [`Module`, `module`], (Super, Self) => {
	return Super.inherit({
		namespace: Self.id,
		defaults: {
			scale: 2,
			zoom: 16,
			render: true,
			blurb: null,
		},
		prepare({ place, blurb }) {
			if (!this.isObject(place)) {
				throw new Error(`Modules/Map(): setup.place is required.`);
			}

			const { Config, DOM, System } = this;
			const system = System.get();
			const { isiOS } = system;
			const viewport = DOM.getViewportDimensions();
			const isMobile = viewport.width < 800;
			const { address, latitude, longitude, name } = place;
			const { streetAddress, extendedAddress, postalCode, state, city } = address;
			const mapUrl = isMobile ? place.mobileMapUrl : place.mapImageUrl;
			const addressArray = [streetAddress, extendedAddress, city, state].filter(Boolean);
			const maps = [name, streetAddress, city, state].filter(Boolean);
			const addressString = blurb || addressArray.join(`, `) + (postalCode ? ` ${postalCode}` : ``);
			const query = encodeURIComponent(maps.join(`, `) + (postalCode ? ` ${postalCode}` : ``));

			let linkUrl;

			if (isiOS) {
				// webview for the iOS Tixr app
				linkUrl = `https://maps.apple.com/?q=${query}`;
			} else {
				// anything else
				linkUrl = `https://www.google.com/maps/preview?q=${query}`;
			}

			this.assign(this.data, {
				addressString,
				blurb,
				googleMapsApiKey: Config.GOOGLE_MAPS_JS_API_KEY,
				latitude,
				linkUrl,
				longitude,
				mapUrl,
				place,
			});
		},
		constructor() {
			const { data } = this;
			const { addressString } = data;

			this.create({
				namespace: `Widgets/ClipboardLink`,
				setup: {
					name: `copy-widget`,
					container: this.get(`a[action="copy"]`),
					content: addressString,
					message: `Copied link to clipboard`,
				},
				done: true,
			});
		},
	});
});

define("Modules/Map.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/Map/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"non-map-blurb\"> <p class=\"address-blurb\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"blurb") : depth0), depth0))
    + "</p> <a href=\"#\" name=\"copy-widget\" action=\"copy\" class=\"button ux4 small tertiary\"> "
    + alias1(lookupProperty(helpers,"getIcon").call(depth0 != null ? depth0 : (container.nullContext || {}),"copy",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":161},"end":{"line":1,"column":179}}}))
    + " </a> </div> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"place") : depth0),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":201},"end":{"line":1,"column":1070}}})) != null ? stack1 : "")
    + " ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <iframe width=\"952\" height=\"434\" style=\"border:0\" loading=\"lazy\" allowfullscreen referrerpolicy=\"no-referrer-when-downgrade\" src=\"https://www.google.com/maps/embed/v1/place?key="
    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"googleMapsApiKey")), depth0))
    + " &q="
    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"addressString")), depth0))
    + "\"> </iframe> <div class=\"non-map\"> <div class=\"info\"> <p class=\"location-name\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</p> "
    + ((stack1 = lookupProperty(helpers,"with").call(alias3,(depth0 != null ? lookupProperty(depth0,"address") : depth0),{"name":"with","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":539},"end":{"line":1,"column":899}}})) != null ? stack1 : "")
    + " </div> <a class=\"open-in-maps button ux4 medium tertiary\" theme=\""
    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0))
    + "\" href=\""
    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"linkUrl")), depth0))
    + "\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,"mappin",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1008},"end":{"line":1,"column":1028}}}))
    + " <p>Open in maps</p> </a> </div> ";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"address-wrapper\"> <p class=\"address\">"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"streetAddress") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":606},"end":{"line":1,"column":681}}})) != null ? stack1 : "")
    + alias2(lookupProperty(helpers,"join").call(alias1,(depth0 != null ? lookupProperty(depth0,"city") : depth0),(depth0 != null ? lookupProperty(depth0,"state") : depth0),", ",{"name":"join","hash":{},"data":data,"loc":{"start":{"line":1,"column":681},"end":{"line":1,"column":705}}}))
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"postalCode") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":705},"end":{"line":1,"column":774}}})) != null ? stack1 : "")
    + "</p> <a href=\"#\" name=\"copy-widget\" action=\"copy\" class=\"button ux4 small tertiary\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"copy",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":859},"end":{"line":1,"column":877}}}))
    + " </a> </div> ";
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(lookupProperty(helpers,"join").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"streetAddress") : depth0),(depth0 != null ? lookupProperty(depth0,"extendedAddress") : depth0),", ",{"name":"join","hash":{},"data":data,"loc":{"start":{"line":1,"column":627},"end":{"line":1,"column":670}}}))
    + "<br>";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"state") : depth0),{"name":"unless","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":723},"end":{"line":1,"column":752}}})) != null ? stack1 : "")
    + " "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"postalCode") : depth0), depth0));
},"9":function(container,depth0,helpers,partials,data) {
    return ",";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"blurb") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":1078}}})) != null ? stack1 : "");
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=Map.js.map